export const hasPermission = (userPermissions = [], required) => {
  if (!required) return true;
  if (Array.isArray(required)) {
    return required.some((perm) => userPermissions.includes(perm));
  }
  return userPermissions.includes(required);
};

export const hasAllPermissions = (userPermissions = [], required = []) => {
  if (!required.length) return true;
  return required.every((perm) => userPermissions.includes(perm));
};

export const hasRole = (userRoles = [], required) => {
  if (!required) return true;
  if (Array.isArray(required)) {
    return required.some((role) => userRoles.includes(role));
  }
  return userRoles.includes(required);
};

export const filterByPermission = (items = [], userPermissions = []) =>
  items.filter((item) => !item.permission || hasPermission(userPermissions, item.permission));

export default { hasPermission, hasAllPermissions, hasRole, filterByPermission };
